
import HomeIcon from '@mui/icons-material/Home';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode';
import TurnedInIcon from '@mui/icons-material/TurnedIn';

export const ROUTES = [
    {
        title: "Home",
        route: 0,
        icon: <HomeIcon/>,
    },
    {
        title: "Register",
        route: 1,
        icon: <AppRegistrationIcon/>,
    },
    {
        title: "Venue",
        route: 2,
        icon: <StorefrontIcon/>
    },
    {
        title: "Agenda",
        route: 3,
        icon: <ViewAgendaIcon/>
    },
    {
        title: "Confirmed Speakers",
        route: 4,
        icon: <InterpreterModeIcon/>
    },
    {
        title: "Abstract Submission",
        route: 5,
        icon: <TurnedInIcon/>
    }
]